export async function getMe() {
  const token = sessionStorage.getItem('token');
  const res = await fetch(`${process.env.REACT_APP_API_URL}/api/me`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  if (!res.ok) { const error = new Error('Falha ao carregar /api/me'); error.status = res.status; throw error; }
  return res.json(); // { user, entitlements, trial_active }
}